import { NgModule } from '@angular/core';

import { FormValueService } from 'src/app/common/guards/save-data-guard/form-value.service';
import { LongOperationModule } from 'src/app/common/long-operations/long-operations.module';
import { OperationInfoService } from 'src/app/common/long-operations/operation-info.service';
import { PipesModule } from 'src/app/common/pipes/pipes.module';
import { FormsConstructorModule } from 'src/app/forms/forms-constructor.module';
import { SharedModule } from 'src/app/shared.module';
import { CardsModule } from 'src/app/views/cards/cards.module';
import { SortElementsModule } from 'src/app/views/sort-elements/sort-elements.module';
import { ViewsModule } from 'src/app/views/views.module';
import { ChatModule } from '../chat/chat.module';
import { CreatePostComponent } from './create-post/create-post.component';
import { CreatePostService } from './create-post/create-post.service';
import { CommentComponent } from './post-detail-info/comments/comment/comment.component';
import { CommentsPaginationComponent } from './post-detail-info/comments/comments-pagination/comments-pagination.component';
import { CommentsComponent } from './post-detail-info/comments/comments.component';
import { PostDetailCommentsService } from './post-detail-info/post-detail.comments.service';
import { PostDetailComponent } from './post-detail-info/post-detail.component';
import { PostDetailService } from './post-detail-info/post-detail.service';
import { PostsNavigationComponent } from './posts-navigation.component';
import { PostsRoutingModule } from './posts-routing.module';
import { PostsService } from './posts.service';
import { UpdatePostComponent } from './update-post/update-post.component';
import { UserPostsComponent } from './user-posts/user-posts.component';

@NgModule({
  imports: [
    SharedModule,
    PostsRoutingModule,
    FormsConstructorModule,
    CardsModule,
    ViewsModule,
    PipesModule,
    ChatModule,
    LongOperationModule,
    SortElementsModule,
  ],
  declarations: [
    PostsNavigationComponent,
    CreatePostComponent,
    UserPostsComponent,
    PostDetailComponent,
    UpdatePostComponent,
    CommentsComponent,
    CommentComponent,
    CommentsPaginationComponent,
  ],
  exports: [PostDetailComponent, UpdatePostComponent, CommentsComponent, CommentComponent, CommentsPaginationComponent],
  providers: [
    CreatePostService,
    PostDetailService,
    PostDetailCommentsService,
    PostsService,
    FormValueService,
    OperationInfoService,
  ],
})
export class PostsModule {}
